import { Link } from '@idexx-laboratories/spot-react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import CheckboxValueGroup from '../../components/CheckboxValueGroup/CheckboxValueGroup';
import { GridRendererProps } from '../../components/Grid/Grid';
import { useStore } from '../../hooks/use-store';
import { ResourcePermission, RoleApi } from '../../types/users-types';

export const RoleDefinitionRenderer = observer((props: GridRendererProps<RoleApi>) => {
  const { row } = props;
  const store = useStore().rolesManagementStore;
  return (
    <Link
      className='cancel-editing'
      size='small'
      onClick={() => store.showRolePermissions(row)}
      data-testid={`link-${row.name}`}
    >
      {row.name}
    </Link>
  );
});

export const PermissionsRenderer = observer((props: GridRendererProps<ResourcePermission>) => {
  const { row, index, tableId } = props;
  const store = useStore().roleManagementStore;

  const changeIndices = (newIndices: number[]): void => {
    runInAction(() => {
      store.edited = true;
      row.permissions.forEach((p, i) => {
        p.checked = newIndices.includes(i);
      });
    });
  };

  return (
    <CheckboxValueGroup
      id={`${tableId}_permissions-group__${index}`}
      variant='horizontal'
      small
      values={row.permissions}
      displayField='id'
      onChange={indices => changeIndices(indices)}
      checkedIndices={row.permissions.map((p, i) => (p.checked ? i : -1)).filter(i => i > -1)}
      data-testid='user-role'
    />
  );
});
